module.exports = __webpack_public_path__ + "img/dresser.a0089141.jpg";